import React from 'react';
import { UserAvatar } from '@applyboard/ui-components';
import { _User, _UserName, _UserPic } from "../styles";
import { joinNames } from "../../EditStudentTabs/StudentInfo/utils";
var User = function User(_ref) {
  var firstName = _ref.firstName,
    lastName = _ref.lastName,
    email = _ref.email,
    image = _ref.image,
    id = _ref.id;
  return /*#__PURE__*/React.createElement(_User, null, /*#__PURE__*/React.createElement(_UserPic, null, /*#__PURE__*/React.createElement(UserAvatar, {
    avatar: image,
    firstName: firstName,
    lastName: lastName,
    email: email,
    id: id
  })), /*#__PURE__*/React.createElement(_UserName, null, joinNames([firstName, lastName]) || email));
};
export default User;